import React from 'react';
import { ApplySection } from '../../components/ApplySection';
import VenueBg from '../../assets/images/venue/venue-bg.jpg';
import './venue.css';
import { HeroSecondary } from '../../components/HeroSecondary';

import StayInStyleImg from '../../assets/images/venue/stay-in-style.png';
import WorldClassDiningImg from '../../assets/images/venue/world-class-dining.png';
import NextStyleConferenceImg from '../../assets/images/venue/next-level-conference.png';

import Button from '../../components/Button';
import ExperienceCard from '../../components/ExperienceCard';

function VenuePage() {
  const experiences = [
    {
      id: 1,
      title: 'Stay in Style and Comfort!',
      text: 'Experience the ultimate in comfort and style at the MGM Grand Las Vegas. Enjoy spacious and elegantly designed rooms and suites, each equipped with modern amenities to ensure a relaxing stay during Ai4 2024.',
      photo: StayInStyleImg,
    },
    {
      id: 2,
      title: 'World-Class Dining and Cocktails',
      text: "Indulge in a culinary journey at the MGM Grand's diverse selection of restaurants and eateries. From Michelin-starred fine dining to casual eateries, there's something to satisfy every palate. Attendees can enjoy exquisite meals and socialize in the vibrant dining spaces.",
      photo: WorldClassDiningImg,
    },
    {
      id: 3,
      title: 'Next-Level Conference Hosting',
      text: 'The MGM Grand boasts top-notch conference facilities, perfectly suited for hosting Ai4 2024. With cutting-edge audio-visual equipment, ample meeting spaces, and a professional team, the venue ensures a seamless and productive event for all attendees.',
      photo: NextStyleConferenceImg,
    },
  ];

  return (
    <div className="venue-page">
      <HeroSecondary
        title={"Venue: <br/>MGM Grand, Las Vegas"}
        bgImage={VenueBg}
      />
      <div className="book-section">
        <h2>Ai4 will take place at <span className="text-gradient">The MGM Grand</span> located at 3799 S Las Vegas Blvd, Las Vegas, NV 89109.</h2>
        <p>
          Our original block of hotel rooms at the MGM Grand has sold out. We have been able to add a small amount of additional rooms at discounted rates. They likely won’t last long so book soon if you plan to do so.
        </p>
        <Button label="Book your stay" />
      </div>
      <div className="reserve-section">
        <h2>Elevate Your Conference Experience!</h2>
        <div className="row flex-wrap justify-content-center gap-18 experiences-row">
          {
            experiences.map(item => (
              <ExperienceCard content={item} />
            ))
          }
        </div>
        <Button label="RESERVE NOW" />
      </div>
      <ApplySection
        title="Did you save the date ?"
        description="Mark Your Calendar for the Unmissable Event: Ai4 2024 at The MGM Grand. Secure Your Spot Today and Be Part of the Premier AI Conference of the Year!"
        buttonLabel="BOOK YOUR ROOM NOW"
      />
    </div>
  );
}

export default VenuePage;
